import "bxslider/dist/jquery.bxslider.css";

const BXSLIDER_CONFIG = {
  auto: 0,
  mode: "fade",
  speed: 1e3,
  pause: 6500,
  infiniteLoop: false,
  controls: false,
  nextText: "",
  prevText: "",
  touchEnabled: false,
  fadeFirstSlide: false,
  startSlide: 0,
  autoStart: true,
};

let bxsliderLoaded = false;

function bindSliderControls(slider) {
  $(".previous-slide-main-left").on("click", () => {
    slider.goToPrevSlide();
    return false;
  });

  $(".next-slide-main-left").on("click", () => {
    slider.goToNextSlide();
    return false;
  });
}

window.initBxSlider = (overrides) => {
  const target = document.querySelector(".room-slider");
  if (!target) return Promise.resolve();

  const config = Object.assign({}, BXSLIDER_CONFIG, overrides || {});

  if (bxsliderLoaded) {
    const slider = $(".room-slider").bxSlider(config);
    bindSliderControls(slider);
    return Promise.resolve(slider);
  }

  return import("bxslider/dist/jquery.bxslider").then(() => {
    bxsliderLoaded = true;
    const slider = $(".room-slider").bxSlider(config);
    bindSliderControls(slider);
    return slider;
  });
};

window.addEventListener("DOMContentLoaded", () => {
  if (typeof window.initBxSlider === "function") window.initBxSlider();
});
